import { post } from './common';

interface BatchTranslateOptions {
  Phrases: Record<string,string>;
}

const translate = (phrase: string): Promise<string> => {
    return post('/Services/TranslationService.asmx/Translate', {
        Phrase:phrase
    })
        .then((resp:Response) => {
            return resp.json();
        })
        .then((json) => {
            return json.d;
        })

}
const batchTranslate = (payload: BatchTranslateOptions): Promise<Response> => {
    return post('/Services/TranslationService.asmx/batchTranslate', payload);
};

export { translate, batchTranslate };
